import { BaseInput } from "./BaseInput";

export default function TextInput({ value, onChange }) {
  return (
    <BaseInput
      value={value}
      onChange={onChange}
      placeholder="Enter answer"
      style={{
        fontSize: "20px",
        padding: "8px",
        width: "200px",
        marginTop: "10px"
      }}
    />
  );
}
